<template>
  <div class="pay">
    <el-dialog title="服务订购"
               :visible.sync="dialogVisible"
               width="1100px"
               :before-close="handleClose">
      <div class="main ">
        <div class="box-list" v-if="comboList.length > 0">
          <div class="main-list"
               v-for="(item, index) in comboList"
               :key="index">
            <div class="list">
              <div :class="`head head${index % 3}`">
                <h4>
                  <img :src="imgList[index % 3]"
                       alt="" />
                  <p>{{ item.name }}</p>
                </h4>
                <p class="explain">{{ item.explain }}</p>
              </div>
              <div class="con">
                <h4>
                  ￥<span>{{ item.amount }}</span>/
                  {{ item.time_option == "0_0" ? "未设置" : item.time_option == "1_year" ? "年" : item.time_option == "3_month" ? "3个月" : item.time_option == "1_month" ? "月" : "" }}
                </h4>
                <p style="padding:10px 0">功能亮点</p>
                <div class="list">
                  <ul>
                    <li v-for="(v, i) in item.service"
                        :key="i">{{ v.name }}</li>
                  </ul>
                </div>
                <div class="btn-list">
                  <el-button class="btn btn0"
                             @click="step(item)">开通{{ item.name }}</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
         <el-empty description="暂无内容"
                  v-else></el-empty>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <!-- <p>合计： <span>5555.00</span> 元</p>
                <el-button type="primary" @click="dialogVisible = false">下一步</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PayDia",
  data () {
    return {
      dialogVisible: false,
      imgList: [require("@/assets/icon/icon_jianctyb.png"), require("@/assets/icon/icon_jiancbzb.png"), require("@/assets/icon/icon_jiancqjd.png")],
    };
  },
  props: {
    comboList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    handleClose () {
      this.dialogVisible = false;
    },
    step (item) {
      this.$emit("step", item);
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  min-height: 500px;
  padding: 20px;
  overflow: scroll;
  .box-list {
    display: flex;
  }
  .main-list {
    display: inline-block;
    width: 310px;
    min-height: 300px;
    border: 1px solid #d4d4d4;
    border-radius: 2px;
    margin-right: 30px;
    .list {
      width: 100%;
      box-sizing: border-box;
      /*  display: flex;
      justify-content: center; */
      .item {
        background: #ffffff;
        display: flex;
        flex-direction: column;
      }
    }
    .head {
      width: 100%;
      box-sizing: border-box;
      padding: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      h4 {
        display: flex;
        align-content: center;
        p {
          // margin-left: 8px;
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: 600;
          color: #fff;
        }
      }
      .explain {
        display: flex;
        justify-content: center;
        width: 300px;
        padding: 10px;
        //   white-space: wrap !important;
        /*     word-break: break-all; */
        //margin-top: 12px;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
      }
    }
  }
}
.con {
  text-align: center;
  padding: 10px 0 0 0;
  /* padding: 20px; */
  h4 {
    font-size: 16px;
    color: #333;
    span {
      font-size: 32px;
      margin: 0 4px;
    }
  }
  .btn {
    text-align: center;
  }
  .list {
    // margin-top: 10px;
    ul {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      li {
        list-style: none;
        color: #333;
        font-size: 14px;
        line-height: 36px;
        position: relative;
        text-align: left;
        padding-left: 80px;
        &::before {
          position: absolute;
          content: "√";
          font-size: 18px;
          color: #2448ff;
          left: 50px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
}
.btn-list{
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}

.head0 {
  background: linear-gradient(90deg, #407fff, #34aeff);
  border: 1px solid #d4d4d4;
  border-radius: 2px 2px 0px 0px;
}

.head1 {
  background: linear-gradient(90deg, #397af9, #32d9d4);
  border: 1px solid #d4d4d4;
  border-radius: 2px 2px 0px 0px;
}

.head2 {
  background: linear-gradient(90deg, #eeb88e, #b67951);
  border: 1px solid #d4d4d4;
  border-radius: 2px 2px 0px 0px;
}
.btn {
  /*  margin: 20px; */
  font-weight: 400;
  color: #2448ff;
}
.btn0 {
  display: flex;
  background: linear-gradient(0deg, #407fff 0%, #34aeff 98.6328125%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.btn1 {
  background: linear-gradient(90deg, #397af9, #32d9d4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.btn2 {
  background: linear-gradient(90deg, #eeb88e, #b67951);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
::v-deep .dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  p {
    margin-right: 40px;
    span {
      color: red;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
</style>